import { ChangeDetectionStrategy, Component, input } from '@angular/core';
import { KcIconComponent } from '@kaspacom/ui-kit';

export interface NavCrumb {
  readonly label: string;
  readonly isCurrent: boolean;
}

@Component({
  selector: 'kcc20-nav-breadcrumb',
  standalone: true,
  imports: [KcIconComponent],
  templateUrl: './nav-breadcrumb.component.html',
  styleUrl: './nav-breadcrumb.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class NavBreadcrumbComponent {
  readonly crumbs = input.required<NavCrumb[]>();
}
